var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupeeWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 25C49 38.2548 38.2548 49 25 49C11.7452 49 1 38.2548 1 25C1 11.7452 11.7452 1 25 1C38.2548 1 49 11.7452 49 25ZM5.32 25C5.32 35.869 14.131 44.68 25 44.68C35.869 44.68 44.68 35.869 44.68 25C44.68 14.131 35.869 5.32 25 5.32C14.131 5.32 5.32 14.131 5.32 25Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3298_135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3298_135",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4016 11.5625H10.6016V40.3625H39.4016V11.5625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3298_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 14.9298C34.4369 14.9298 34.7936 14.7821 35.0566 14.5191C35.3196 14.2561 35.4674 13.8994 35.4674 13.5274C35.4674 13.1555 35.3196 12.7988 35.0566 12.5358C34.7936 12.2728 34.4369 12.125 34.0649 12.125H16.9571C16.5852 12.125 16.2285 12.2728 15.9655 12.5358C15.7025 12.7988 15.5547 13.1555 15.5547 13.5274C15.5547 13.8994 15.7025 14.2561 15.9655 14.5191C16.2285 14.7821 16.5852 14.9298 16.9571 14.9298H22.8465C23.7162 14.931 24.5642 15.2012 25.2742 15.7034C25.9842 16.2056 26.5214 16.9152 26.8121 17.7348H16.9571C16.5852 17.7348 16.2285 17.8826 15.9655 18.1456C15.7024 18.4086 15.5547 18.7653 15.5547 19.1373C15.5547 19.5092 15.7024 19.8659 15.9655 20.1289C16.2285 20.392 16.5852 20.5397 16.9571 20.5397H26.8121C26.5214 21.3593 25.9842 22.0689 25.2742 22.5711C24.5642 23.0733 23.7162 23.3435 22.8465 23.3446H17.0506C16.783 23.3447 16.5209 23.4213 16.2954 23.5655C16.0699 23.7096 15.8904 23.9153 15.778 24.1583C15.6657 24.4012 15.6251 24.6712 15.6613 24.9364C15.6974 25.2016 15.8086 25.4509 15.9819 25.6549L27.5739 39.3054C27.6927 39.4469 27.8384 39.5636 28.0025 39.6487C28.1666 39.7338 28.3459 39.7856 28.5301 39.8011C28.7143 39.8167 28.8997 39.7956 29.0757 39.7393C29.2518 39.6829 29.4149 39.5922 29.5558 39.4726C29.6967 39.3529 29.8125 39.2065 29.8966 39.0419C29.9808 38.8773 30.0315 38.6977 30.046 38.5135C30.0604 38.3292 30.0383 38.1439 29.9809 37.9682C29.9235 37.7925 29.8319 37.6298 29.7114 37.4897L20.0814 26.1497H22.8467C26.2326 26.1497 29.0655 23.7366 29.717 20.5399H34.0651C34.4355 20.5376 34.79 20.3888 35.0511 20.126C35.3122 19.8633 35.4587 19.5079 35.4587 19.1375C35.4587 18.7671 35.3122 18.4117 35.0511 18.1489C34.79 17.8862 34.4355 17.7374 34.0651 17.735H29.717C29.5091 16.7176 29.0769 15.7594 28.4519 14.9301H34.0649L34.0649 14.9298Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3298_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "translate(10.6016 10.6016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeWhiteCircle);
export default __webpack_public_path__ + "static/media/rupee_white_circle.aa68b0aae03792077ace06fa36879f5c.svg";
export { ForwardRef as ReactComponent };